import HomePage from "./views/HomePage/HomePage.vue";
import LoginPage from "./views/LoginPage.vue";
import ModelLoadingPage from "./views/temp/deprecated/ModelLoadingPage.vue";

import SettingsPage from "./views/SettingsPage.vue";
import NoticePage from "./views/temp/dev/Notice/NoticePage.vue";

import AssetStorePage from "./views/temp/dev/AssetStore/AssetStorePage.vue";

import LiveRemotePage from "./views/LiveRemote/LiveRemotePage.vue";
import OnAirPage from "./views/OnAir/OnAirPage.vue";
import BroadcastManagePage from "./views/BroadcastManage/BroadcastManagePage.vue";
import BroadcastGamePage from "./views/BroadcastGame/BroadcastGamePage.vue";
import PetSettingPage from "./views/PetSetting/PetSettingPage.vue";
import TrainingPage from "./views/Pet/TrainingPage.vue";

// 버츄패스 전환: /subscribe·/subscription 라우트 제거(파일은 참고용 보존). 구독 진입은 /currency/gather?tab=pass

import OnboardingPage from "./views/Onboarding/OnboardingPage.vue";
import UserSetupPage from "./views/Onboarding/UserSetupPage.vue";

import PetSelectPage from "./views/Pet/PetSelectPage.vue";
import PetStorePage from "./views/Pet/PetStorePage.vue";
import HospitalPage from "./views/Pet/HospitalPage.vue";
import RankingPage from "./views/Pet/RankingPage.vue";
import GatherPage from "./views/Currency/GatherPage.vue";
import SlotPage from "./views/Currency/SlotPage.vue";
import PricingPage from "./views/Pricing/PricingPage.vue";

const routes = [
  {
    path: "/home",
    name: "Home",
    component: HomePage,
  },
  {
    path: "/my/broadcast",
    name: "LiveRemote",
    component: LiveRemotePage,
  },
  {
    // 개발용 (사이드바 보임 — name이 isHide 목록에 없음)
    path: "/on-air/dev",
    name: "OnAirDev",
    component: OnAirPage,
    meta: { favicon: "favicon-onair.svg" }, // 방송중 빨간 점
  },
  {
    // 방송관리 = 플랫폼(치지직/트위치/SOOP) 연동
    path: "/broadcast/setting",
    name: "BroadcastManage",
    component: BroadcastManagePage,
  },
  {
    // 방송게임 — 시청자 참여 미니게임 (준비중)
    path: "/broadcast/game",
    name: "BroadcastGame",
    component: BroadcastGamePage,
  },
  {
    // 펫 설정 (이름/배경/좌우반전) — 구 /broadcast/setting
    path: "/pet/setting",
    name: "PetSetting",
    component: PetSettingPage,
  },
  {
    // 훈련하기 (펫에게 반응 학습) — 준비 중
    path: "/pet/training",
    name: "Training",
    component: TrainingPage,
  },
  {
    // 리액션 (구 방송하기 '모션' 다이얼로그를 페이지로 이관) — 리액션 선택/미리보기
    path: "/my/pet/reaction",
    name: "Motion",
    component: () => import("./views/Pet/MotionPage.vue"),
  },
  {
    // OBS 브라우저 소스용 (사이드바 숨김 — name "OnAir"가 isHide 목록에 있음)
    path: "/on-air",
    name: "OnAir",
    component: OnAirPage,
    meta: { favicon: "favicon-onair.svg" }, // 방송중 빨간 점
  },
  // 구 경로 호환: 기존 OBS에 등록된 /live·/live/dev 링크가 깨지지 않게 /on-air로 리다이렉트(?t= 쿼리 보존).
  { path: "/live/dev", redirect: (to) => ({ path: "/on-air/dev", query: to.query }) },
  { path: "/live", redirect: (to) => ({ path: "/on-air", query: to.query }) },
  {
    path: "/temp/dev/asset-store",
    name: "AssetStore",
    component: AssetStorePage,
  },
  {
    path: "/user/setting",
    name: "Settings",
    component: SettingsPage,
  },

  // 펫 선택 (캐릭터 선택 스타일)
  {
    path: "/pet/select",
    name: "PetSelect",
    component: PetSelectPage,
  },
  // 방송 허브 (카테고리 페이지 — 방송하기/방송관리를 카드로). NAV_CATEGORIES의 to로 매칭.
  {
    path: "/broadcast",
    name: "BroadcastHub",
    component: () => import("./views/CategoryHub/CategoryHubPage.vue"),
  },
  // 버츄펫 월드 허브 (카테고리 페이지 — 서브 아이템을 카드로). NAV_CATEGORIES의 to로 매칭.
  {
    path: "/world",
    name: "WorldHub",
    component: () => import("./views/CategoryHub/CategoryHubPage.vue"),
  },
  // 소셜(SNS) 허브 (숏폼/인생네컷/랭킹 카드). NAV_CATEGORIES의 to로 매칭.
  {
    path: "/social",
    name: "SnsHub",
    component: () => import("./views/CategoryHub/CategoryHubPage.vue"),
  },
  // 내 버츄펫 허브 (카테고리 페이지). NAV_CATEGORIES의 to로 매칭.
  {
    path: "/my",
    name: "MyHub",
    component: () => import("./views/CategoryHub/CategoryHubPage.vue"),
  },
  // 보유 아이템 (인벤토리)
  {
    path: "/my/items",
    name: "MyItems",
    component: () => import("./views/My/MyItemsPage.vue"),
  },
  // 펫스토어 (악세사리 카드 목록)
  {
    path: "/pet/store",
    name: "PetStore",
    component: PetStorePage,
  },
  // 병원 (검사/치료)
  {
    path: "/pet/hospital",
    name: "Hospital",
    component: HospitalPage,
  },
  // 병원 > 선호도 검사 (좋아하는 음식 알아내기)
  {
    path: "/pet/hospital/favorite",
    name: "FavoriteExam",
    component: () => import("./views/Pet/FavoriteExamPage.vue"),
  },
  // 펫 랭킹 (레벨순)
  {
    path: "/pet/ranking",
    name: "Ranking",
    component: RankingPage,
  },
  // 당근채집 (🥕 채집 미니게임 + 구매하기 탭)
  {
    path: "/currency/gather",
    name: "CurrencyGather",
    component: GatherPage,
  },
  // 슬롯머신 (베팅 → 페이지 이동)
  {
    path: "/currency/gather/slot",
    name: "SlotGame",
    component: SlotPage,
  },
  // SNS > 소셜 방송 캔버스 (배경색 + 펫 자유 배치, 텍스트/사진 예정)
  {
    path: "/social/broadcast",
    name: "SocialBroadcast",
    component: () => import("./views/Social/SocialBroadcastPage.vue"),
  },

  // SNS > 숏폼 (실험실에서 승격 — 사이드바 유지)
  {
    path: "/social/short-form",
    name: "ShortForm",
    component: () => import("./views/ShortForm/ShortFormPage.vue"),
  },

  // 실험실(Local) > 뇌구조 데모 — echarts-wordcloud 지연 로딩(메인 번들 무영향)
  {
    path: "/lab/brain",
    name: "BrainWordCloud",
    component: () => import("./views/Lab/BrainWordCloudPage.vue"),
  },

  // SNS > 인생네컷 (현재 펫 랜덤 모션 4컷 캡처)
  {
    path: "/social/life-four-cut",
    name: "LifeFourCut",
    component: () => import("./views/Sns/LifeFourCutPage.vue"),
  },

  {
    // 팬 공간 랜딩 (placeholder). 팬 로그인 복귀 시 이동.
    path: "/fan",
    name: "FanHome",
    component: () => import("./views/Fan/FanHomePage.vue"),
  },
  {
    // 팬 > 추천 방송 (준비 중)
    path: "/fan/recommend",
    name: "FanRecommend",
    component: () => import("./views/Fan/FanPlaceholderPage.vue"),
    meta: { title: "추천 방송" },
  },
  {
    // 팬 > 펫 검색 (펫 이름으로 공개 검색)
    path: "/fan/pet-search",
    name: "FanPetSearch",
    component: () => import("./views/Fan/FanPetSearchPage.vue"),
  },
  {
    // 팬 > 내가 만든 리액션 (creator_id=나)
    path: "/fan/reactions",
    name: "FanMyReactions",
    component: () => import("./views/Fan/FanMyReactionsPage.vue"),
  },
  {
    path: "/login",
    name: "Login",
    component: LoginPage,
  },

  {
    // 공개 가격 페이지 (Paddle 온보딩 제출용 + 일반 공개). 로그인 불필요 = protectedPaths에 없음.
    path: "/pricing",
    name: "Pricing",
    component: PricingPage,
  },

  {
    path: "/temp/dev/notice",
    name: "NOtice",
    component: NoticePage,
  },

  {
    path: "/temp/deprecated/model-loading",
    name: "ModelLoading",
    component: ModelLoadingPage,
  },
  {
    // 리액션 씬 편집기 (멀티트랙 타임라인, 베타)
    path: "/reaction/editor",
    name: "ReactionEditor",
    component: () => import("./views/reaction/ReactionEditor/ReactionEditorPage.vue"),
  },
  {
    path: "/404",
    name: "404",
    component: () => import("./views/404Page.vue"),
  },

  // ONBOARDING 1단계: 사용자설정(닉네임)
  {
    path: "/user/new",
    name: "Onboarding",
    component: UserSetupPage,
  },
  // 펫 생성 (첫 셋업 ?mode=setup / 펫 추가 둘 다 사용)
  {
    path: "/pet/new",
    name: "PetNew",
    component: OnboardingPage,
  },

  {
    // 정책 정적 페이지 별칭: /policy/terms → /policy/terms.html (catch-all보다 먼저)
    path: "/policy/:doc(terms|privacy|refunds)",
    beforeEnter(to) {
      // 정적 HTML로 하드 이동 (next() 미호출 → SPA 네비게이션은 페이지 언로드로 중단)
      window.location.replace(`/policy/${to.params.doc}.html`);
    },
    component: { render: (h) => h("div") }, // 더미: 리다이렉트 전 잠깐 마운트되는 빈 컴포넌트
  },
  {
    path: "/",
    redirect: "/login",
  },
  {
    path: "*",
    redirect: "/404",
  },
];

export default routes;
